import * as React from 'react';
import _reject from 'lodash/reject';

import { useSnackbar } from 'notistack';
import { EventReportFilter } from '../../api/clients';

type UseEventReportFiltersResult = {
  eventReportFilters: EventReportFilter[];
  addEventReportFilter: (eventReportFilter: EventReportFilter) => void;
  removeEventReportFilter: (eventReportFiler: EventReportFilter) => void;
};

function useEventReportFilters(): UseEventReportFiltersResult {
  const [eventReportFilters, setEventReportFilters] = React.useState<EventReportFilter[]>([] as EventReportFilter[]);
  const { enqueueSnackbar } = useSnackbar();
  const validateFilters = (filter: EventReportFilter) => {
    if (filter.field?.toLowerCase().includes('date')) {
      const dateRegex = /(0[1-9]|1[0,1,2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d{2}/;
      if (!filter.value || !dateRegex.test(filter.value)) {
        const errorMessage = `Invalid date format ${filter.value}. Expected format is 'MM/DD/YYYY'.`;
        enqueueSnackbar(errorMessage, { variant: 'warning', persist: false });
        return false;
      }
    }

    return true;
  };

  const addEventReportFilter = (eventReportFilter: EventReportFilter) => {
    if (!validateFilters(eventReportFilter)) {
      return;
    }
    setEventReportFilters((prevState: EventReportFilter[]) => (
      [..._reject(prevState, (f) => f.field === eventReportFilter.field), eventReportFilter]
    ));
  };

  const removeEventReportFilter = (eventReportFilter: EventReportFilter) => {
    setEventReportFilters((prevState: EventReportFilter[]) => (
      _reject(prevState, (f) => f.field === eventReportFilter.field)
    ));
  };
  const data = React.useMemo(() => ({ eventReportFilters, addEventReportFilter, removeEventReportFilter }), [eventReportFilters]);
  return {
    ...data,
  };
}

export default useEventReportFilters;
